export const getSamplePartNumberCsvData = (): string[][] => [
  ['part_number', 'description'],
  ['5841-01-528-4987', 'hydraulic pump'],
  ['5310-00-164-1100', 'washer, flat'],
  ['813R250G01', 'spare valve'],
  ['999999999', ''],
];
